<template lang="pug">
  select( class="e-year-select" v-model="$parent[year]" @change="$emit('onSelectItem', $parent[year])")
    template(v-if="yearsOptions")
        option(v-if="placeholder" value="" v-bind:disabled="disablePlaceholderOption") {{placeholder}}
        option(v-for="option in yearsOptions" :value="option") {{option}}
</template>

<script>
  import year from  '../../utils/year.js'
  import { map } from '../../api/api-endpoints.js'
  export default {
    name: 'e-year-selector',
    props: {
      /**
       * Parent year name
       */
      year: {
        type: String,
        default: null,
        required: true
      },
      placeholder: {
        type: String,
        default: null
      },
      disablePlaceholderOption: {
        type: Boolean,
        default: true
      }
    },
    methods:{
      getYearUrl(){
        return map.yearFuture()
      }
    },
    computed:{
      yearsOptions(){
        return this.$store.state.years
      }
    },
    created() {
      this.$store.dispatch('updateUrlEndpoint',{ endpoint: this.getYearUrl(),fromCache: true})
        .then(r=>{
          let _yearsOptions = [];
          r.data.year.forEach(i=>{
            _yearsOptions.push(i.year)
          })
          this.$store.commit('setYears', _yearsOptions)
        }).catch(e=>{
          console.log(e)
        })
    }
  }
</script>
